// extracted by mini-css-extract-plugin
export default {"container":"FranchiseeCampaing_container__e3H-2","grid_list":"FranchiseeCampaing_grid_list__ksFLh scroll-menu","card":"FranchiseeCampaing_card__ubuR1"};